import { FC } from 'react';
import { CheckBox, Label, Root } from './style';

export interface InputTextProps {
  name: string;
  [x: string]: any;
}

const Toggle: FC<InputTextProps> = ({ name, ...props }) => {
  return (
    <Root>
      <CheckBox id={name} name={name} value={props.value} type="checkbox" {...props} />
      <Label htmlFor={name} />
    </Root>
  );
};

export default Toggle;
